import { createStyles, type WithStyles, withStyles } from "@material-ui/core";
import { ConfigurationItem } from "constants/configurations";
import React, { useEffect } from "react";
import AjusteEscoreContainer from "../../ajusteEscore/views/ajusteEscoreContainer";
import CadastroIngredientesContainer from "../../cadastroIngredientes/views/cadastroIngredientesContainer";
import CategoryContainer from "../../category/views/categoryContainer";
import CauseOfDeathContainer from "../../causeOfDeath/views/causeOfDeathContainer";
import CorralContainer from "../../corral/views/corralContainer";
import ListagemFormulacaoContainer from "../../formulacao/views/formulationList/listagemFormulacaoContainer";
import GoalPlanRouter from "../../goalPlan/views/goalPlanRouter";
import LotGoalContainer from "../../lotGoal/views/lotGoalContainer";
import LotsContainer from "../../lots/views/lotsContainer";
import PesagemCategoriaContainer from "../../pesagemCategoria/views/pesagemCategoriaContainer";
import PlanningRouter from "../../planning/views/planningRouter";
import GanhoPesoContainer from "../../projecaoGanhoPeso/views/ganhoPesoContainer";
import RainHistoryContainer from "../../rainHistory/views/rainHistoryContainer";
import type { ConfigurationItemsVisibility } from "../configurations.types";
import { useConfigurationTabAnalytics } from "../hooks/useConfigurationTabAnalytics";

type ConfigurationTabContentProps = {
  hasSelectedFarm: boolean;
  isTabChangeRequested: boolean;
  itemsVisibility: ConfigurationItemsVisibility;
  onCancelChangeTab: () => void;
  onConfirmChangeTab: () => void;
  selectedTab: ConfigurationItem;
  setInterceptOnChangeTab: (intercept: boolean) => void;
  targetTabChange: ConfigurationItem | null;
} & WithStyles<typeof styles>;

function ConfigurationTabContent({
  hasSelectedFarm,
  isTabChangeRequested,
  itemsVisibility,
  onCancelChangeTab,
  onConfirmChangeTab,
  setInterceptOnChangeTab,
  selectedTab,
  targetTabChange,
}: ConfigurationTabContentProps) {
  const { trackEvent } = useConfigurationTabAnalytics({ tab: selectedTab });

  useEffect(() => {
    trackEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!hasSelectedFarm) {
    return null;
  }

  if (selectedTab === ConfigurationItem.ANIMAL_CATEGORY) {
    return (
      <CategoryContainer
        showLotSize={true}
        showWeightGain={itemsVisibility.showWeightGain}
        showWeightGainCurve={true}
      />
    );
  }

  if (
    selectedTab === ConfigurationItem.CAUSE_OF_DEATH &&
    itemsVisibility.showCauseOfDeath
  ) {
    return <CauseOfDeathContainer />;
  }

  if (selectedTab === ConfigurationItem.CORRAL_LISTING) {
    return <CorralContainer />;
  }

  if (selectedTab === ConfigurationItem.FARM_GOALS) {
    return <GoalPlanRouter />;
  }

  if (
    selectedTab === ConfigurationItem.FORMULATIONS &&
    itemsVisibility.showFormulationRegistration
  ) {
    return <ListagemFormulacaoContainer />;
  }

  if (
    selectedTab === ConfigurationItem.HERD_EVOLUTION_AND_NUTRITION_PLAN &&
    itemsVisibility.showHerdEvolutionAndNutritionPlan
  ) {
    return (
      <PlanningRouter
        changeInterceptOnChangeTab={setInterceptOnChangeTab}
        changeTabRequested={isTabChangeRequested}
        confirmChangeTab={onConfirmChangeTab}
        onCancelChangeTab={onCancelChangeTab}
        tabToChange={targetTabChange}
      />
    );
  }

  if (selectedTab === ConfigurationItem.INGREDIENTS) {
    return <CadastroIngredientesContainer />;
  }

  if (
    selectedTab === ConfigurationItem.LOT_GOALS &&
    itemsVisibility.showLotGoal
  ) {
    // eslint-disable-next-line react/jsx-no-undef
    return <LotGoalContainer />;
  }

  if (selectedTab === ConfigurationItem.PLOT_LISTING) {
    return <LotsContainer />;
  }

  if (
    selectedTab === ConfigurationItem.RAIN_HISTORY &&
    itemsVisibility.showRainHistory
  ) {
    return <RainHistoryContainer />;
  }

  if (
    selectedTab === ConfigurationItem.SCORE_ADJUSTMENT &&
    itemsVisibility.showScoreAdjustment
  ) {
    return <AjusteEscoreContainer />;
  }

  if (selectedTab === ConfigurationItem.WEIGHING_BY_CATEGORY) {
    return <PesagemCategoriaContainer />;
  }

  if (selectedTab === ConfigurationItem.WEIGHT_GAIN_CURVE) {
    return <GanhoPesoContainer />;
  }

  return null;
}

const styles = () => createStyles({});

export default withStyles(styles)(ConfigurationTabContent);
